
import { Component, Vue } from 'vue-property-decorator';
import { items } from '../../data/community';

@Component({
  components: {},
})
export default class CommunityComponent extends Vue {
  items = items;

  redirectTo(href: string) {
    window.open(href, '_blank');
  }
}
